import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from '@chakra-ui/react';
import { Todo as TodoType } from '../types';
import { todoKindMeta } from './lib';
import TodoDocument from './TodoDocument';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  todo: TodoType;
}

function Todo({ isOpen, onClose, todo }: Props) {
  const { title } = todoKindMeta(todo.target.__typename, todo.kind);

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{title}</DrawerHeader>
        <DrawerBody>
          {todo.target.__typename === 'Document' && <TodoDocument todo={todo} onClose={onClose} />}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

export default Todo;
